<template>
  <div>
    
      </div>
</template>

<script>
import axios from "axios";
  import thumbbar from "@/components/training/thumb-bar.vue";
    import CourseItem from "@/components/training/course-item.vue";

export default {
        props: {},
        components: {
            thumbbar,
            CourseItem
        },
  data() {
      return {
          courseData: [
              {
                  id: "1",
                  thumb: "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLB29sWmMcqW5XrmP6IibRZAmibyocfHtVnicEsicP3NavgrQAGGvQk9qWxhILwibT4ib4dJM/356",
                  title: "C#5-跨平台深度学习入门与项目实战",
                  num: "1233",
                  rate: 4,
              },
              {
                  id: "2",
                  thumb: "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLAdmTbic5y5kwZmbP7TLa8A0iclQddeBk3UB4icEttskabIxLzhfYwl7dQjJ5wNQ7fFiac/356",
                  title: "超高效！新手必学的AE动效制作全流程",
                  num: "1233",
                  rate: 5,
              },
              {
                  id: "3",
         
                  thumb: "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLBhLOcxd2DWkjwWUXYvgZicLvU0S7gUWZM9m2RCbJbDvt3HViaG621wVcibfvmqk7NVGA/356",
                  title: "超高效！MYSQL增删改查操作实操",
                  num: "1233",
                  rate: 4,
              },
              {
                  id: "4",
                  thumb: "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLBhLOcxd2DWkjwWUXYvgZicLvU0S7gUWZM9m2RCbJbDvt3HViaG621wVcibfvmqk7NVGA/356",
                  title: "IOS+Swift零基础教程(带你玩转IOS)",
                  num: "1233",
                  rate: 4,
              },
              {
                  id: "5",
                  thumb: "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLCoNyJwbmOLtEXr8PA0UrSlhBIeLNgvTfCcOSWJdwFrRtH6YWuib0ROeIdy84PlBeVs/356",
                  title: "Java Web实战特训营-高级进阶",
                  num: "1233",
                  rate: 5,
              },
              {
                  id: "6",
                  thumb: "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLAKAFJw1ypsCtU5TKsic6yycex2ZQSknichF6IIR1G8MribmgxUN9OgdzAjOk3iaeXlfxg/356",
                  title: "k8s&doceker容器特训实战",
                  num: "1233",
                  rate: 4,
              },
              {
                  id: "7",
                  thumb: "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLCUDBxXtW69z3jZ2zSGnytzAMfQXzw8UNibO2taIx1OpdBUwiaFJ1Lvyurnpg4arh2J0/356",
                  title: "C++基本介绍,跨平台利器",
                  num: "1233",
                  rate: 4,
              },
              {
                  id: "8",
                  thumb: "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLAkEriceW0qbqibMat9Jj2oiao7wSLoGtEjQvXgiaWyNteJ1FN1uDDKnDric4ticoickUz6OE/356",
                  title: "小程序应用与开发-零基础",
                  num: "1233",
                  rate: 5,
              }
          ],
        trainData: [
            {
                id: "1",
                thumb: "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLDRlBHnfUB5rk0MicYNBl84yT7ORvH2DoXRUpRFq1DQ3goxjzb2ia21WVOxsZlTvpAUg/356",
                title: "超高效！新员工办公软件训练营",
                status: "0",
                progress: 0,
                date: "2023.07.08 ~ 2023.12.31",
            },
            {
                id: "2",
                thumb: "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLCjEkX8OnW8eBZcNkh5SDscfpASXjM6RXNkMzUGUKUgxzZIcef0iccwaMR0X5ia7libC8/356",
                title: "职场必修技能-职业规划/沟通技巧/情商培养/人际关系/团队管理",
                status: "1",
                progress: 50,
                date: "2023.07.08 ~ 无期限",
            },
            {
                id: "3",
                thumb: "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLAhiaXxHBQnKMLCpb0QAEloBLjOng5jB3MH95XLP1yC8IwPBhthFe7VXNDdLialUm1Xs/356",
                title: "金蝶财务软件使用教程财务软件记账电脑操作指导课",
                status: "1",
                progress: 80,
                date: "2023.07.08 ~ 2023.12.31",
            },
            {
                id: "4",
                thumb: "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLDseHJoWEHD3abQJniaMvu7GSySicViaNJLuGQelS5x4r21rANb8TZdO6o3fUSMn3XZbo/356",
                title: "超高效！Python财务分析基础",
                status: "1",
                date: "2023.07.08 ~ 2023.12.31",
                progress: 80,
            },
            {
                id: "5",
                thumb: "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLAtK9JlwfNSSPY8NkdyWxv2ISia9Fz38KnthcZwNy3DlYgagmlbPiarBtzaEEpkhGkKY/356",
                title: "超高效！财务估值案例合集",
                status: "1",
                date: "2023.07.08 ~ 2023.12.31",
                progress: 80,
            },
            {
                id: "6",
                thumb: "https://10.idqqimg.com/qqcourse_logo_ng/ajNVdqHZLLBEXsVyPE6unxmdslnmtKAN7QDzzqOFqCEQkOic5hxr6TyreamJZk8R3N0A6unKdialw/356",
                title: "软件测试（银行领域）- 带你了解商业银行",
                status: "1",
                date: "2023.07.08 ~ 2023.12.31",
                progress: 80,
            },
        ],
        trainSwiper: [], 
        
    };
  },
  created() {
      this.requestTraining();
  },
  mounted() {
      this.getSwiperData();
  },
  destroyed() {
    
  },
        methods: {
            getSwiperData() {
                let dataList = this.trainData; //获取到数据
                for (let i = 0; i < dataList.length; i += 4) {
                    this.trainSwiper.push(dataList.slice(i, i + 4));
                }
            },
            handleClose() {
                this.$emit("closepop"); //通知父组件改变。
            },
            requestTraining() {
                //Api.getExamUserInfo()
                //    .then((res) => {
                //        this.waitExamCount = res.data.waitExamCount;
                //    })
                //    .catch((err) => {
                //        console.warn(err);
                //    });
                //Api.getList(this.listQuery)
                //    .then((res) => {
                //        this.examList = res.data.items;
                //        this.examList.forEach((item) => {
                //            item.isHover = false;
                //        });
                //    })
                //    .catch((err) => {
                //        console.warn(err);
                //    });
            },
            goDetail(item) {
                this.$router.push({
                    name: "pkgDetail",
                    query: {
                        id: item.id,
                    },
                });
            },
        }
};
</script>

<style lang="scss" scoped>
    ::v-deep .el-carousel__button {
        height: 5px;
        border-radius: 5px;
    }
    ::v-deep .el-progress-bar__innerText {
        font-size: 14px !important;
    }
    ::v-deep .el-progress__text {
        font-size: 14px !important;
        color: #999999 !important;
    }
    .message-modal {
        max-width: 1300px;
        margin: 60px auto;
        text-align: center;

        .title {
            font-size: 38px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: 600;
            text-align: center;
            color: #1e2046;

            img {
                margin-top: 6px;
                margin-right: 16px;
                width: 39px;
                height: 33px;
            }
        }

        .description {
            width: 1360px;
            height: 651px;
            align-items: center;
            justify-content: normal;
            margin: 24px 0px;
            display: flex; //把盒子在一行显示
            overflow-x: hidden; //超出隐藏
            flex-wrap: wrap; //超出自动换行

            & .nothree {
                justify-self: flex-start;
            }

            .empty {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 1044px;
                height: 192px;
                background: #ffffff;
                border-image: linear-gradient(148deg, #ffffff 1%, #ffffff 90%) 2 2;
                border-radius: 18px;
                box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.04);
                // flex-direction: column;
                font-size: 18px;
                font-weight: 400;
                text-align: center;
                color: #666666;
                line-height: 54px;
            }

            .group-item {
                width: 305px;
                height: 312px;
                background: rgba(255,255,255,0.20);
                border-image: linear-gradient(148deg, #ffffff 1%, #ffffff 90%) 2 2;
                border-radius: 28px;
                box-shadow: 1px 1px 1px 1px rgba(0,0,0,0.04);
                transition: all .3s ease-in-out;
                position: relative;
                margin: 0px 12px;


                &:hover {
                    bottom: 0px;
                    box-shadow: 0 4px 8px #6666661a;

                    .vod-course-thumb {
                        .thumb-bar {
                            transform: scale(1.1, 1.1);
                        }
                    }
                }

                .vod-course-thumb {
                    width: 305px;
                    height: 172px;
                    border-radius: 8px 8px 0px 0px;
                    overflow: hidden;

                    .thumb-bar {
                        width: 100%;
                        height: 100%;
                        transition: all .3s;
                    }
                }

                .item {
                    cursor: pointer;
                    padding: 5px 16px 5px 24px;
                }


                .name {
                    font-size: 18px;
                    // font-family: PingFangSC, PingFangSC-Medium;
                    font-weight: 700;
                    text-align: left;
                    color: #000000;
                    line-height: 22px;
                    margin: 12px 0;
                }

                .progress {
                    margin-top: 10px;
                }

                .des {
                    display: flex;
                    position: relative;
                    align-items: center;
                    align-self: center;
                    margin-top: 10px;
                    justify-content: space-between;

                    .num {
                        width: 35px;
                        height: 17px;
                        font-size: 14px;
                        font-weight: 700;
                        text-align: left;
                        color: #666666;
                        line-height: 17px;
                    }

                    .word {
                        width: 42px;
                        height: 20px;
                        font-size: 14px;
                        font-weight: 400;
                        text-align: right;
                        color: #666666;
                        line-height: 20px;
                    }

                    .no-start {
                        width: 10px;
                        height: 10px;
                        background: #d8d8d8;
                        border-radius: 50%;
                    }

                    .learning {
                        width: 10px;
                        height: 10px;
                        background: #ff6c75;
                        border-radius: 50%;
                    }

                    .status {
                        width: 42px;
                        height: 20px;
                        font-size: 14px;
                        font-weight: 500;
                        text-align: left;
                        color: #666666;
                        line-height: 20px;
                    }

                    .date-section {
                        width: 180px;
                        height: 24px;
                        background: #f5f5f5;
                        border-radius: 12px;

                        .date {
                            width: 131px;
                            height: 14px;
                            font-size: 12px;
                            font-weight: 700;
                            text-align: left;
                            color: #999999;
                            line-height: 14px;
                        }
                    }
                }

                .exam-date {
                    font-size: 12px;
                    // font-family: PingFangSC, PingFangSC-Regular;
                    font-weight: 400;
                    text-align: left;
                    color: #999999;
                    line-height: 17px;
                }

                &.end {
                    margin-right: 0 !important;
                }
            }
        }

        .file-btn {
            width: 126px;
            cursor: pointer;
            height: 42px;
            // opacity: 0.47;
            border: 1px solid #cacaca;
            font-size: 16px;
            // font-family: PingFangSC, PingFangSC-Semibold;
            font-weight: 600;
            color: #000000;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .elective-btn {
            width: 126px;
            height: 42px;
            background: rgba(31,163,255,0.09);
            color: #1fa3ff;
            border-radius: 21px;
            font-size: 16px;
            font-weight: 600;
            text-align: left;
            line-height: 22px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

        ::v-deep .el-carousel__indicator.is-active button {
            opacity: 1;
            background-color: #1fa3ff !important;
        }

        ::v-deep .el-carousel__button {
            background-color: #e2e4e8;
        }

        ::v-deep .el-carousel__indicator--horizontal .el-carousel__button {
            width: 10px;
            height: 10px;
            background: rgba(124,124,124,0.32);
            border-radius: 50%;
        }

        ::v-deep .el-carousel__indicator--horizontal.is-active .el-carousel__button {
            /* opacity: 1;*/
            width: 14px;
            height: 14px;
            background: #1fa3ff;
            border-radius: 50%;
        }
 
</style>